export const SUB_PAGE_IDS = ['#adset-page-audience', '#adset-page-details', '#adset-page-materials', '#adset-page-summary'] as const;
export const STEP_IDS = ['#adset-step-audience', '#adset-step-details', '#adset-step-materials', '#adset-step-summary'] as const;

export function showSubPage(id: typeof SUB_PAGE_IDS[number]): void {
  SUB_PAGE_IDS.forEach(sub => $(sub).addClass('d-none'));
  $(id).removeClass('d-none');
}

export function setActiveStep(stepId: typeof STEP_IDS[number]): void {
  const idx = STEP_IDS.indexOf(stepId);
  STEP_IDS.forEach((s, i) => {
    const $el = $(s);
    $el.removeClass('active inactive completed');
    if (i < idx) $el.addClass('completed');
    else if (i === idx) $el.addClass('active');
    else $el.addClass('inactive');
  });
}
